/**
 * 纯函数：后台动态路由权限过滤（可单测，不依赖 Vuex/Router）
 */

const LEGACY_ALIAS = {
  'system:adminUser': ['system:admin'],
  'order:order': ['business:order'],
  'user:user': ['business:user'],
  'driver:driver': ['business:driver'],
  'driver:withdraw': ['business:withdraw'],
  'driver:apply': ['business:driverApply', 'operation:driverApply'],
  'content:banner': ['business:banner'],
  'content:category': ['business:category'],
  'content:service': ['business:service'],
  'content:coupon': ['operation:coupon'],
  'content:announcement': ['operation:announcement'],
  'order:appeal': ['operation:appeal'],
  'order:ratingTag': ['operation:ratingTag'],
  'user:realname': ['operation:realname'],
  'user:finance': ['operation:userFinance'],
  'driver:announcement': ['operation:driverAnnouncement'],
  'driver:report': ['operation:driverReport']
}

export function isSuperAdminUser({ roles = [], isSuper = false, userInfo = {} } = {}) {
  if (isSuper) return true
  if ((roles || []).includes('super_admin') || (roles || []).includes('admin')) return true
  if (Number(userInfo.id) === 1) return true
  if (userInfo.username === 'admin') return true
  return false
}

export function hasPermission(permissions, route) {
  // 无 permission 的目录节点：由子路由过滤结果决定
  if (!(route.meta && route.meta.permission)) return true

  const code = route.meta.permission
  const list = permissions || []
  if (list.includes(code)) return true
  if (list.includes('*')) return true

  // 父级 xxx:view 不能解锁全部二级菜单
  const aliases = LEGACY_ALIAS[code] || []
  return aliases.some(a => list.includes(a))
}

export function filterAsyncRoutes(routes, permissions, ctx = {}) {
  const res = []
  const permSet = permissions || []
  const superAdmin = isSuperAdminUser(ctx)

  ;(routes || []).forEach(route => {
    const tmp = { ...route }
    if (tmp.path === '*') {
      res.push(tmp)
      return
    }
    if (tmp.hidden && tmp.redirect && !tmp.component && !tmp.children) {
      res.push(tmp)
      return
    }

    if (tmp.children && tmp.children.length) {
      tmp.children = filterAsyncRoutes(tmp.children, permSet, ctx)
    }

    if (superAdmin) {
      res.push(tmp)
      return
    }

    if (!hasPermission(permSet, tmp)) return

    if (Array.isArray(route.children) && route.children.length) {
      const visibleKids = (tmp.children || []).filter(c => !(c.meta && c.meta.hidden) && !c.hidden)
      if (!visibleKids.length) return
      if (tmp.redirect && typeof tmp.redirect === 'string') {
        const childPaths = visibleKids.map(c => {
          if (!c.path) return tmp.path
          if (c.path.startsWith('/')) return c.path
          return `${tmp.path}/${c.path}`.replace(/\/+/g, '/')
        })
        if (!childPaths.includes(tmp.redirect)) {
          tmp.redirect = childPaths[0]
        }
      }
    }
    res.push(tmp)
  })
  return res
}

/** 侧栏可见菜单：一级 title + 二级 title 列表 */
export function collectVisibleMenus(routes) {
  const menus = []
  ;(routes || []).forEach(r => {
    if (!r || r.hidden || (r.meta && r.meta.hidden)) return
    if (r.path === '*' || r.path === '/404' || r.path === '/login') return
    if (r.redirect && !r.component && !r.children) return

    const children = (r.children || []).filter(c => !(c.hidden || (c.meta && c.meta.hidden)))
    if (children.length) {
      menus.push({
        path: r.path,
        title: (r.meta && r.meta.title) || r.path,
        children: children.map(c => ({
          path: c.path,
          title: (c.meta && c.meta.title) || c.path,
          permission: c.meta && c.meta.permission
        }))
      })
    } else if (r.meta && r.meta.title) {
      menus.push({ path: r.path, title: r.meta.title, children: [] })
    }
  })
  return menus
}

export function flattenLeafPermissions(menus) {
  const set = new Set()
  menus.forEach(m => {
    ;(m.children || []).forEach(c => {
      if (c.permission) set.add(c.permission)
    })
  })
  return [...set].sort()
}
